<template>
  <div>
    <div class="wrap-style">
      <div class="page-style">
        <div class="vertical-title">
          <div class="title-text">五<br/>金<br/>箱</div>
        </div>
        <div class="fields-area">
          <div class="line1">
            <div style="width: 86px;line-height:40px">物料编码：</div>
            <div class="line1-right underline" style="font-size: 27px;font-weight:600">{{ formData.hardwarePrint.itemCode }}</div>
          </div>
          <div class="line1">
            <div style="width: 86px">物料名称：</div>
            <div class="line1-right underline">{{ formData.hardwarePrint.itemName }}</div>
          </div>
          <div class="line1">
            <div style="width: 86px">规格描述：</div>
            <div class="line1-right underline">{{ formData.hardwarePrint.specification }}</div>
          </div>
          <div class="line1">
            <div style="width: 56px">单号：</div>
            <div class="line1-right underline">{{ formData.hardwarePrint.dispatchNumber }}</div>
          </div>
        </div>
      </div>
<!--      <div class="footer-print">{{ printTime }}  打印</div>-->
    </div>
  </div>

</template>

<script>

export default {
  name: 'HardwareLabelPrint',
  props: {},
  data () {
    return {
      printTime: '',
      formData: {
        hardwarePrint: {}, // 五金箱信息
        hardwareParentPrint: {} // 配套成品信息
      }
    }
  },
  created () {},
  methods: {
    show (data) {
      this.$set(this.formData, 'hardwarePrint', data.hardwarePrint || {})
      this.$set(this.formData, 'hardwareParentPrint', data.hardwareParentPrint || {})
      this.printTime = this.$moment(new Date()).format('YYYY年MM月DD号')
    }
  }
}
</script>

<style scoped lang="less">
.wrap-style{
  page-break-after: always;
  padding: 5px 2px;
}
.page-style{
  width: 100%;
  max-width: 520px;
  margin: 0 auto; // 水平居中
  font-family: Arial !important;
  display: flex;
  align-items: stretch; // 左右两侧高度保持一致
}
// 左侧竖排标题
.vertical-title{
  width: 65px;
  display: flex;
  justify-content: center;
  align-items: center; // 垂直居中展示
  position: relative;
  padding: 0 6px 0 0; // 与右侧内容的上下边距保持一致
  box-sizing: border-box;
  border-right: 1px solid #808080; // 使用实体边框，打印更稳定
}
.title-text{
  font-family: Arial !important;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.05;
}

// 右侧字段区域
.fields-area{
  width: calc(100% - 65px);
  padding: 0 0 0 10px; // 与左侧保持一致，不再为打印时间留空间
  box-sizing: border-box;
}
.title{
  font-size: 14px !important;
  font-weight: 800;
}
.line1{
  font-family: Arial !important;
  // font-weight: 600;
  display: flex;
  width: 100%;
  font-size: 14px;
  margin: 4px 0; // 缩小行间距
  .line1-left{
    font-family: Arial !important;
    width: 20%; // 缩小左列宽度
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    height: 20px;
  }
  .line1-right{
    font-family: Arial !important;
    width: 100%;
    font-size: 14px;
    display: flex;
    align-items: center;
    padding: 0 4px; // 缩小左右内边距
    min-height: 20px;
  }
}
// 下划线样式
.underline{
  border-bottom: 1px solid #c2c2c2;
}
// 打印时间单独一行
.footer-print{
  font-family: Arial !important;
  width: 100%;
  max-width: 520px;
  margin: 4px auto 0;
  text-align: right;
  font-size: 12px;
}

.ml1 {
  margin-left: 3.5px;
}
.mlr3{
  margin-left: 11px;
  margin-right: 11px;
}
.mlr4 {
  margin-left: 3.5px;
  margin-right: 3.5px;
}
.mr36{
  margin-right: 36px;
}

@media print {
  .page-style{
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    text-rendering: geometricPrecision;
  }
  .vertical-title{
    border-right: 1pt solid #000; // 打印时使用纯黑，保证清晰
  }
  .underline{
    border-bottom: 1pt solid #000; // 打印下划线加深
  }
  .line1{
    color: #000;
  }
  .footer-print{
    color: #000;
  }
  .title-text{
    color: #000;
  }
  .line1-right{
    color: #000;
    -webkit-font-smoothing: antialiased;
  }
}
</style>
